import { Check, Circle } from "lucide-react";

export const InstagramChecklist = ({ kit }) => {
  const p = kit.promo || {}, c = kit.carousel || {};
  const items = [["caption", "Caption", !!p.caption], ["carousel", "Carousel", !!c.slides?.length], ["story", "Story", !!c.stories?.length],
    ["reel", "Reel", !!c.reel], ["image-prompt", "Image prompt", !!p.image_prompt]];
  const done = items.filter((x) => x[2]).length;
  return (
    <div data-testid="instagram-checklist" className="lg:col-span-2 rounded-xl border border-stone-200 bg-white px-6 py-4 flex flex-wrap items-center gap-x-6 gap-y-2">
      <div className="text-sm font-semibold text-[#2B2A26]">Instagram pack · {done}/{items.length} ready</div>
      {items.map(([id, label, ok]) => (
        <span key={id} data-testid={`ig-check-${id}`} className={`inline-flex items-center gap-1.5 text-xs ${ok ? "text-emerald-700" : "text-stone-400"}`}>
          {ok ? <Check size={13} /> : <Circle size={11} />} {label}
        </span>
      ))}
    </div>
  );
};
